import { FC, useState } from 'react';

import { TabItem, Tabs } from '@adeccoux/tag-ds';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box, Drawer, IconButton, Paper } from '@mui/material';

interface DataCheckerDetailsProps {
  detailControls: any;
}

const DcResultType = {
  DOCUMENT: 'DOCUMENT',
};

const DataCheckerDetails: FC<DataCheckerDetailsProps> = ({ detailControls }) => {
  const { isActiveDcDetails, onClose, selectedDcResults } = detailControls;
  const [, setActiveTab] = useState(DcResultType.DOCUMENT);

  const tabChangeHandler = (selectedTab: any) => {
    setActiveTab(selectedTab);
  };

  return (
    <Drawer open={isActiveDcDetails} anchor="right" onClose={onClose}>
      <div className="admin" style={{ height: '100%', padding: '30px', maxWidth: 800, minWidth: 550 }}>
        <div className="oo-mail-overview-container">
          <Box display="flex" mb={2} justifyContent="space-between">
            <div>
              <h3>Verification Details</h3>
            </div>
            <IconButton onClick={onClose}>
              <CloseRoundedIcon color="primary" />
            </IconButton>
          </Box>
        </div>
        <div className="tag-ds ">
          <Tabs onChangeTab={tabChangeHandler}>
            <TabItem id={DcResultType.DOCUMENT} title="Document">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  bgcolor: '#F8F8F9',
                  borderRadius: 2,
                }}
              >
                <Box
                  component="pre"
                  sx={{
                    p: 2.5,
                    overflow: 'auto',
                    fontSize: '14px',
                    lineHeight: '24px',
                    color: '#1C304B',
                    fontWeight: 400,
                  }}
                >
                  {JSON.stringify(selectedDcResults, null, 2)}
                </Box>
              </Paper>
            </TabItem>
          </Tabs>
        </div>
      </div>
    </Drawer>
  );
};

export default DataCheckerDetails;
